import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DistributionRule } from '@generated/tcea/models/distribution-rule';
import { DistributionJobRequest } from '@generated/tcea/models/distribution-job-request';

@Injectable()
export abstract class AbstractDistributionRulesService {
  abstract getRules(
    brandId: string,
    params: {
      size?: number;
      page?: number;
      filter?: Array<string>;
      archived?: boolean;
    },
  ): Observable<{ data: DistributionRule[]; pages: number }>;
  abstract getRuleById(brandId: string, ruleId: string): Observable<DistributionRule>;
  abstract create(brandId: string, ruleData: DistributionRule): Observable<DistributionRule>;
  abstract update(
    brandId: string,
    ruleId: string,
    ruleData: DistributionRule,
  ): Observable<DistributionRule>;
  abstract addJob(
    brandId: string,
    ruleId: string,
    jobData: DistributionJobRequest,
  ): Observable<DistributionRule | DistributionJobRequest>;
  abstract cancelJob(brandId: string, jobId: string): Observable<DistributionJobRequest>;
  abstract editJob(
    brandId: string,
    jobData: DistributionJobRequest,
  ): Observable<DistributionRule | DistributionJobRequest>;
  abstract getJobsForRule(brandId: string, ruleId: string): Observable<DistributionJobRequest[]>;
}
